export const useFindLocation = () => {
  const findLocation = async (locationType, address) => {
    try {
      // Encode the address — business names with & or # corrupt the query
      // string otherwise.
      const geocodeApiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
        address
      )}&key=${import.meta.env.VITE_GEOCODE_API_KEY}`;
      const response = await fetch(geocodeApiUrl);
      const data = await response.json();
      const addressLat = data.results[0]?.geometry.location.lat ?? null;
      const addressLong = data.results[0]?.geometry.location.lng ?? null;

      const formattedLocationAddress =
        data.status === 'ZERO_RESULTS'
          ? null
          : data.results[0]?.formatted_address;
      const newCoords =
        locationType === 'departure'
          ? {
              pickUpLat: addressLat,
              pickUpLong: addressLong,
            }
          : {
              dropOffLat: addressLat,
              dropOffLong: addressLong,
            };

      return { newCoords, formattedLocationAddress };
    } catch (error) {
      console.error('Error finding location:', error);
    }
  };

  return { findLocation };
};